export const readOnlyOptions = [
  { id: '1', text: 'Read only' },
  { id: '0', text: 'Read and write' },
]
